import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateUiAction } from 'actions/uiActions'
import { updateFloorPlanAction, destroyFloorPlanAction, scaleFloorPlanAction } from 'actions/floorPlanActions'
import { messageAction } from 'actions/messageActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Slider from 'rc-slider'
import clamp from 'ramda/src/clamp'

const mapStateToProps = ({ map: { floorPlans }, currentEntity: { id } }) => {
  const currentFloorplan = floorPlans.find(f => f.id === id)
  return { currentFloorplan }
}

class FloorPlanDetails extends React.Component {
  render() {
    const { currentFloorplan: { id, locked, overlay, name, opacity }, updateUiAction,
      updateFloorPlanAction, destroyFloorPlanAction, scaleFloorPlanAction, classes } = this.props

    return (
      <div className={classes.floorPlanDetails}>
        <div className={classes.topUiControls}>
          <a onClick={_ => updateUiAction({ sidebarView: 'cameraList' })}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            All Project Items
          </a>
          <a
            onClick={_ => {
              if (locked) {
                this.props.messageAction('generalError', 'Cannot delete locked floorplan. Right click to unlock.')
              } else if (window.confirm(`Are you sure you want to delete ${this.props.name || `Floor Plan ${id}`}?`)) {
                destroyFloorPlanAction(id)
              }
            }}
            className={classes.destroyButton}>
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        <div className={classes.container}>
          <div title={'Name'} className={classes.nameLabel}>Name</div>
          <div className={classes.textWrapper}>
            <input
              type='text'
              className={classes.nameInput}
              onChange={({ target: { value } }) => {
                updateFloorPlanAction(id, { name: value })
              }}
              value={name || `Floor Plan ${id}`}
            />
          </div>
          <div className={classes.floorPlanActions}>
            <a onClick={_ => updateFloorPlanAction(id, { locked: !locked })}>
              <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} className={classes.lockButton} />
            </a>
            <a onClick={_ => overlay.map.fitBounds(overlay.getBounds())} >
              <FontAwesomeIcon icon='map-marker-alt' className={classes.targetButton} />
            </a>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <a onClick={_ => scaleFloorPlanAction(id)} className={classes.scaleButton}>
            <FontAwesomeIcon icon='expand-arrows-alt' className={classes.scaleIcon} />Scale Floor Plan
          </a>
        </div>
        <div className={classes.container}>
          <div title='Opacity' className={classes.label}>Opacity</div>
          <div className={classes.sliderContainer}>
            <Slider
              min={0.5}
              max={1}
              value={clamp(0.5, 1, opacity || 1)}
              onChange={value => updateFloorPlanAction(id, { opacity: value })}
              step={0.05}
              marks={{ 0.5: '', 1: '' }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, updateFloorPlanAction, destroyFloorPlanAction, scaleFloorPlanAction, messageAction })(injectSheet(style)(FloorPlanDetails))



// WEBPACK FOOTER //
// ./src/components/FloorPlan/FloorPlanDetails/index.js